// src/context/auth/auth.context.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { LOGIN_USER } from "../../graphql/mutation/auth.mutation";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const [loginUserMutation, { loading }] = useMutation(LOGIN_USER);

  // ✅ Rehydrate user from storage on refresh
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const login = async (username, password) => {
    const { data } = await loginUserMutation({
      variables: { username, password },
    });

    const { jwt, user } = data.login;

    if (jwt) localStorage.setItem("jwt", jwt);
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
      setUser(user);
    }

    return true; // ✅ return flag to allow redirect outside
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("jwt");
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
